import React from 'react';

import metricTypeCheckers from '../../../types/metricTypeCheckers';
import Row from '../../Common/Row';
import Typography from 'kingpin/atoms/Typography';
import getMetricInfoLabel from './getMetricInfoLabel';
import CoreBadge from '../../../screens/DataManager/Metrics/CoreBadge';
import useCompoundMetricWithMetricDefs from '../../../hooks/useCompoundMetricWithMetricDefs';
import Expression from '../Expression';
import { MetricLink } from './MetricCard';
import { isNormalMetricInfo } from 'hooks/kpiTypeCheckers';
import Button from '../../../kingpin/atoms/Button';
import MetricInfoConstants from '../constants';

const CompoundInfoHeading = ({
  metricInfo,
  compoundMetric,
  hideLinks,
}: {
  metricInfo: MetricsInfoButton.NormalMetricInfo;
  compoundMetric: Metrics.CompoundMetric;
  hideLinks?: boolean;
}) => {
  const compoundMetricWithDefs = useCompoundMetricWithMetricDefs(
    compoundMetric.id,
  );
  if (!compoundMetricWithDefs) {
    return null;
  }

  return (
    <>
      <Row
        centerAlign
        spaceBetween
        style={{ height: MetricInfoConstants.TOP_BAR_HEIGHT }}
      >
        <Row centerAlign>
          <div style={{ marginRight: 8 }}>
            <Typography.Header type="H5">
              {getMetricInfoLabel(metricInfo)}
            </Typography.Header>
          </div>

          <CoreBadge metric={compoundMetric} />
        </Row>
        {!hideLinks && <MetricLink metric={compoundMetric} />}
      </Row>
      {compoundMetric.name !== getMetricInfoLabel(metricInfo) && (
        <Typography.Body type="Body 12">{compoundMetric.name}</Typography.Body>
      )}
      <Expression
        expression={compoundMetric.expression}
        usedMetrics={compoundMetricWithDefs.metrics}
      />
      {compoundMetric.description !== '' && (
        <div style={{ marginTop: '8px' }}>
          <div style={{ marginRight: 4 }}>
            <Typography.Body type="Label">Description:</Typography.Body>
          </div>
          <Typography.Body type="Body 12">
            {compoundMetric.description}
          </Typography.Body>
        </div>
      )}
    </>
  );
};

const InfoHeading = ({
  metricInfo,
  close,
  hideClose,
  hideLinks,
}: {
  metricInfo: MetricsInfoButton.MetricInfo;
  close: () => void;
  hideClose?: boolean;
  hideLinks?: boolean;
}) => {
  const hasAliasSubText = isNormalMetricInfo(metricInfo)
    ? !!metricInfo.metricAlias &&
      metricInfo.metricAlias !== metricInfo.metric.name
    : false;
  if (
    isNormalMetricInfo(metricInfo) &&
    metricTypeCheckers.isCompoundMetric(metricInfo.metric)
  ) {
    return (
      <CompoundInfoHeading
        metricInfo={metricInfo}
        compoundMetric={metricInfo.metric}
        hideLinks={hideLinks}
      />
    );
  }

  return (
    <>
      <Row
        centerAlign
        spaceBetween
        style={{ height: MetricInfoConstants.TOP_BAR_HEIGHT }}
      >
        <Row centerAlign>
          <div style={{ marginRight: 4 }}>
            <Typography.Header type="H4">
              {getMetricInfoLabel(metricInfo)}
            </Typography.Header>
          </div>
          {isNormalMetricInfo(metricInfo) && (
            <CoreBadge metric={metricInfo.metric} />
          )}
        </Row>
        {!hideClose && (
          <Button
            size={'Small'}
            type={'Secondary'}
            onClick={close}
            icon="cross"
          />
        )}
      </Row>
      {hasAliasSubText && (
        <div>
          <Typography.Body type="Body 12">
            {isNormalMetricInfo(metricInfo)
              ? metricInfo.metric.name
              : metricInfo.label}
          </Typography.Body>
        </div>
      )}
    </>
  );
};

export default InfoHeading;
